/**
 * Standard user-facing success messages for mutations (save, delete, submit, etc.).
 * Use with useSuccessSnackbar() — not inline strings in pages.
 */

export function savedSuccessfully(what: string): string {
  return `${what} saved successfully.`;
}

export function deletedSuccessfully(what: string): string {
  return `${what} deleted successfully.`;
}

export function submittedSuccessfully(what: string): string {
  return `${what} submitted successfully.`;
}

export function updatedSuccessfully(what: string): string {
  return `${what} updated successfully.`;
}

export function closedSuccessfully(what: string): string {
  return `${what} closed successfully.`;
}

export function acknowledgedSuccessfully(what: string): string {
  return `${what} acknowledged.`;
}

/** Domain-specific messages that do not fit the verb helpers above. */
export const successCopy = {
  highFiveSavedToWeek: 'High five saved to this week.',
  checkInScheduleSet: (employeeName: string, frequency: string, firstDue: string) =>
    `Check-in schedule for ${employeeName} set to ${frequency}, first due ${firstDue}.`,
  checkInDisabled: (employeeName: string) => `Check-in disabled for ${employeeName}.`,
  checkInsOptedOut: 'Built-in check-ins turned off. Open check-ins for your team were cancelled.',
  checkInsOptedIn: 'Built-in check-ins turned back on. Set a frequency for each team member on My Team when you are ready.',
  objectiveWeightsApplied: (reviewsUpdated: number) =>
    reviewsUpdated === 0
      ? 'No reviews needed updating — weightings were already up to date.'
      : `Weightings applied and scores recalculated for ${reviewsUpdated} review${reviewsUpdated === 1 ? '' : 's'}.`,
  copiedToClipboard: 'Copied to clipboard.',
  askAardvarkPromptCopied: 'Prompt copied — paste it in Claude',
} as const;
